import { useParams, useNavigate } from 'react-router-dom';
import { ExamConfigEditor } from '../components/exam-config/ExamConfigEditor';
import { Button } from '../components/ui/atoms/Button';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ExamConfigPage = () => {
  const { t } = useTranslation('job');
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();

  return (
    <div className="bg-background-gray p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <Button
            type="text"
            intent="secondary"
            size="sm"
            icon={<ArrowLeft/>}
            label={t('exam_config.actions.back')}
            onClick={() => navigate(`/job/${jobId}`)}
          />
          <Button
            type="text"
            intent="secondary"
            size="sm"
            label={t('exam_config.actions.cancel')}
            onClick={() => navigate(`/job/${jobId}`)}
          />
        </div>

        <div className="bg-white rounded-lg h-[calc(100vh-200px)] overflow-hidden">
          <ExamConfigEditor
            jobId={jobId || ''}
            onSaveSuccess={() => navigate(`/job/${jobId}`)}
            onBack={() => navigate(`/job/${jobId}`)}
          />
        </div>
      </div>
    </div>
  );
};
